<template>
  <div class="container-fluid">
    <div v-if="errors && errors.length > 0" class="alert alert-danger">
      {{ getErrorsText }}
    </div>
    <h4 class="mb-5 mr-5">Изменение населенного пункта</h4>
    <el-form ref="form" :model="form" label-position="left" label-width="180px" id="uploadForm" name="uploadForm"
      enctype="multipart/form-data">
      <el-form-item label="Название">
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item label="Стоимость">
        <el-input v-model="form.price"></el-input>
      </el-form-item>
      <el-form-item label="Сумма заказа">
        <el-input v-model="form.minTotalForFree"></el-input>
      </el-form-item>
      <el-form-item label="Разрешен подъем на этаж">
        <el-checkbox v-model="form.hasDeliveryToTheDoor"></el-checkbox>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="store()">Изменить</el-button>
        <el-button @click="back()">Назад</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import axios from "axios";
import getErrors, { getTextErrors } from '../../composable/utils/getErrors';
import useFormData from '../../composable/useFormData'

export default {
  data() {
    return {
      form: {
        name: '',
        price: 0,
        minTotalForFree: 0,
        hasDeliveryToTheDoor: false,
      },
      id: this.$route.params.id,
      errors: [],
    }
  },
  computed: {
    getErrorsText() {
      if (this.errors && this.errors.length > 0) {
        return getTextErrors(this.errors)
      }
      return ''
    }
  },
  mounted() {
    this.getRegion()
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    getRegion() {
      axios.get(`/delivery-region/${this.id}`)
        .then((response) => {
          this.initValues(response.data)
        })
        .catch((errors) => {
          if (errors.response.status === 401) {
            this.$router.push('/login');
          }
        });
    },
    store() {
      const { execute } = useFormData()

      const data = execute().setFields([
        'name',
        'price',
        'minTotalForFree',
        'required',
        'hasDeliveryToTheDoor',
      ]).getFormData(this.form)

      axios.post('/delivery-region/' + this.id, data).then(() => {
        this.back();
      }).catch((errors) => {
        this.errors = errors.response.data.errors;
        if (errors.response.status === 401) {
          this.$router.push('/login');
        }
        if (errors.response.status === 422) {
          this.setErrors(errors.response.data.errors)
        }
      });
    },

    setErrors(err) {
      this.errors = getErrors(err)
    },

    initValues(value) {
      if (value) {
        this.form.name = value.name || '';
        this.form.price = value.price || 0;
        this.form.minTotalForFree = value.min_total_for_free || 0;
        this.form.hasDeliveryToTheDoor = value.has_delivery_to_the_door ?? false;
      }
    }

  }
}
</script>

<style scoped>

</style>